module.exports = "https://static.wmbcdn.com/uniweb/images/6a0fcb4038e30e797ef03e424b6ae7c5.svg";